import HeaderReport from "../../../Components/ComponentsIndustry/HeaderReport";
import CountUp from "react-countup";
import {
  Container,
  SizeContainer,
  ContainerCard,
  Paragraph,
  ImgCard,
  FooterPrice,
  LoanImgCard,
  ImgFooter,
  Popover,
  PulseElement,
  PulseElementVariation,
} from "./style";
import { useUser } from "../../../providers/UserContext";
import { useEffect, useState } from "react";
import axios from "axios";

const Bank = () => {
  const { jogo, industry, rodada, setIndustry } = useUser()
  const [loading, setLoading] = useState(false)
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredInvest, setIsHoveredInvest] = useState(false);
  const [aplicacoes, setAplicacoes] = useState([])
  const [bankData, setBankData] = useState({ valorEmprestimo: "0,00", valorInvest: "0,00" })
  const [saldoDevedor, setSaldoDevedor] = useState(0);
  const [saldoInvest, setSaldoInvest] = useState(0);

  const buscarEmprestimos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/emprestimo/listarEmprestimosIndustria/${industry?.industria}`)
      if (response.data.length > 0) {
        const saldo = response.data.reduce((acc, emprestimo) => {
          return acc += emprestimo.valorParcela
        }, 0)

        setSaldoDevedor(saldo)
      }
    } catch (e) {
      console.log(e);
    }
  }

  const buscarAplicacoes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/investimento/listarInvestimentosAbertoIndustria/${industry?.industria}`)
      if (response.data.length > 0) {
        const saldoInvest = response.data.reduce((acc, investimento) => {
          return acc += investimento.saldo
        }, 0)
        setAplicacoes(response.data)
        setSaldoInvest(saldoInvest)
      }
    } catch (e) {
      console.log(e);
    }
  }

  const moneyMask = (e) => {
    let name = e.target.name
    let value = e.target.value.replace('.', '').replace(',', '').replace(/\D/g, '')

    const options = { minimumFractionDigits: 2 }
    const result = new Intl.NumberFormat('pt-BR', options).format(
      parseFloat(value) / 100
    )

    setBankData(prev => ({ ...prev, [name]: result }))
  }

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  const handleHoverInvestOn = () => {
    setIsHoveredInvest(true);
  };

  const handleHoverInvestOff = () => {
    setIsHoveredInvest(false);
  };

  const pedirEmprestimo = async () => {
    setLoading(true)
    const valor = Number(bankData.valorEmprestimo.replaceAll('.', '').replace(',', '.'))
    if (valor <= 0) return
    try {
      const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/emprestimo/cadastrar`, {
        jogo: jogo?.jogo,
        numParcelas: 1,
        rodada: { rodada: rodada?.rodada },
        valor,
        taxa: jogo?.taxaEmprestimo,
        industria: industry?.industria
      })
      setBankData({ valorEmprestimo: "0,00", valorInvest: "0,00" })
      if (result.data.sucesso) {
        const update_industry = await axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${industry?.industria}`)
        setIndustry(update_industry.data)
        localStorage.setItem('@App:industria', JSON.stringify(update_industry.data));
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  const enviarAplicacao = async () => {
    setLoading(true)
    const valor = Number(bankData.valorInvest.replaceAll('.', '').replace(',', '.'))
    if (valor <= 0) return
    if (valor > industry?.investimentoSaldo) {
      alert('Valor maior que o seu saldo disponível')
      return
    }
    try {
      const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/investimento/cadastrar`, {
        jogo: jogo?.jogo,
        rodada,
        valor,
        taxa: jogo?.taxaInvestimento,
        industria: industry?.industria
      })

      if (result.data.sucesso) {
        const update_industry = await axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${industry?.industria}`)
        setIndustry(update_industry.data)
        localStorage.setItem('@App:industria', JSON.stringify(update_industry.data));
      }
      setBankData({ valorEmprestimo: "0,00", valorInvest: "0,00" })

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const retirarSaldo = async () => {
    setLoading(true)
    try {

      for await (let investimento of aplicacoes) {
        await axios.put(`${process.env.REACT_APP_BASE_URL}/investimento/baixarInvestimento/${investimento?.investimento}/${investimento.rodada.rodada}`)
      }
      const update_industry = await axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${industry?.industria}`)
      setIndustry(update_industry.data)
      setSaldoInvest(0)
      localStorage.setItem('@App:industria', JSON.stringify(update_industry.data));

    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    buscarAplicacoes()
    buscarEmprestimos()
  }, [industry])

  return (
    <Container>
      <SizeContainer>
        <HeaderReport title="Banco" pathImg="./images/bank_button.svg" />
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div><span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>Taxa empréstimo: <span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>{jogo?.taxaEmprestimo}%</span></span></div>
          <div><span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>Taxa investimento: <span style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' }}>{jogo?.taxaInvestimento}%</span></span></div>
        </div>
        <ContainerCard>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Paragraph >Aplicação</Paragraph>
            <Popover onMouseEnter={handleHoverInvestOn} onMouseLeave={handleHoverInvestOff} show={isHoveredInvest}>
              <span>Você possuí um saldo de <br /><CountUp
                style={{ fontSize: '18px', color: 'rgb(42, 250, 165)', fontWeight: 'bold' }}
                prefix="R$ "
                end={saldoInvest}
                separator="."
                decimal=","
                decimals={2}
                duration={0.5}
              /> a serem resgatados, retire agora ou aguarde até a próxima rodada para obter o saldo com retorno da aplicação.</span>

              <div onClick={() => {
                if (!loading) {
                  retirarSaldo()
                }
                return
              }} role='button' style={{ padding: 10, margin: '0 auto', marginTop: 5, backgroundColor: 'rgb(42, 250, 165)', borderRadius: 10, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>Retirar</div>
            </Popover>
            {saldoInvest > 0 ?
              <PulseElementVariation onMouseEnter={handleHoverInvestOn} onMouseLeave={handleHoverInvestOff}>
                <img src="./images/currency-circle-dollar.svg" />
              </PulseElementVariation> : null

            }
          </div>
          <ImgCard src="./images/application_img.svg" />
          <FooterPrice>
            <img src="./images/cifrao.svg" alt='cifrao' />
            <input
              name="valorInvest"
              type="text"
              value={bankData.valorInvest}
              onChange={moneyMask}
            />
            <div role="button" onClick={enviarAplicacao}>
              <img style={{
                height: '70%',
                margin: 0,
                marginLeft: 10
              }} src="./images/paper-plane-right.svg" />
            </div>
          </FooterPrice>
        </ContainerCard>

        <ContainerCard>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Paragraph>Empréstimo</Paragraph>
            <Popover show={isHovered}>
              <span>Você possuí um saldo devedor de <CountUp
                style={{ fontSize: '18px', color: 'red', fontWeight: 'bold' }}
                prefix="R$ "
                end={saldoDevedor}
                separator="."
                decimal=","
                decimals={2}
                duration={0.5}
              /> a serem descontados na próxima rodada! Caso não possua o valor devido, ficará com saldo negativo.</span>
            </Popover>
            {saldoDevedor > 0 ?
              <PulseElement onMouseEnter={handleHover} onMouseLeave={handleHover}>
                <img src="./images/warning-circle.svg" />
              </PulseElement> : null

            }
          </div>
          <LoanImgCard src="./images/loan_img.svg" />
          <FooterPrice>
            <img src="./images/cifrao.svg" alt='cifrao' />
            <input
              name="valorEmprestimo"
              type="text"
              value={bankData.valorEmprestimo}
              onChange={moneyMask}
            />
            <div role="button" onClick={pedirEmprestimo}>
              <img style={{
                height: '70%',
                margin: 0,
                marginLeft: 10
              }} src="./images/paper-plane-right.svg" />
            </div>
          </FooterPrice>
        </ContainerCard>
        <ImgFooter src="./images/character_bank.svg" />
      </SizeContainer>
    </Container >
  );
};
export default Bank;
